export default __webpack_public_path__ + "static/media/Chestguard of Baleful Blood.cf42954c.jpg";